import { EqMagModal } from './EqMagModal';

export const EqMlMagModal = EqMagModal({
  title: 'ML Magnitude',
  desc: 'The ML magnitude was the original magnitude relationship defined by Richter and Gutenberg for local earthquakes in 1935. It is based on the maximum amplitude of a seismogram recorded on a Wood-Anderson torsion seismograph. Although these instruments are no longer widely in use, ML values are calculated using modern instrumentation with appropriate adjustments.',
});
